import React, { Component } from 'react';
import { change, reduxForm } from 'redux-form';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withOnline from '../../common/withOnline';
import withTableName from '../../common/withTableName';
import Header from '../../components/Header';
import { isMobile, onGoBack } from '../../common/globals';
import {
  listSingleCase,
  updateCase,
} from '../../utils/utils';
import {
  getTableCaseByCaseId,
  updateBilledByCaseId,
  updateCaseByCaseId,
  updateMissingDGRsByCaseId,
  updateMissingPOsByCaseId,
  updateNotBilledByCaseId,
  updateTableCaseByPrimaryId,
  updateTableWiseCaseByCaseId,
} from '../../utils/db';
import Bugsnag from '../../helpers/bugsnag';
import withUser from '../../common/withUser.js';
import withReadOnlyProductNotes from '../../common/withReadOnlyProductNotes';

class Notes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      caseData: {},
      ProductNotes: '',
      caseRes: {}
    };
  }

  componentWillUnmount() {
    const { setReadOnlyProductNotes } = this.props;
    setReadOnlyProductNotes(true);
  }

  _getByNotes = async () => {
    try {
      const {
        dispatch, params: { id }, tableName
      } = this.props;
      const caseRes = await getTableCaseByCaseId(id, tableName);
      // const caseRes = await getCaseByCaseId(id);
      if (Object.keys(caseRes).length > 0) {
        this.setState({
          // ProductNotes: caseRes.ProductNotes,
          caseRes
        });
      }

      if (Object.keys(caseRes).length > 0) {
        Object.keys(caseRes).map((key) => {
          dispatch(change('NotesForm', key, caseRes[key]));
        });
        this.setState({ caseRes });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmitNotes = async () => {
    try {
      const {
        online, params: { id }, setLoader, goBack, notify, tableName, user: { name }
      } = this.props;
      const { caseRes: { ProductNotes } } = this.state;
      let responseJson = {};
      const caseData = await getTableCaseByCaseId(id, tableName);
      caseData.ChangeRep = name;

      if (online) {
        caseData.ProductNotes = (ProductNotes === null || ProductNotes === '') ? 'No products used'
          : ((caseData.ProductNotes === ProductNotes) !== undefined
            ? ProductNotes.charAt(0).toUpperCase() + ProductNotes.slice(1)
            : 'No products used');

        caseData.ProductSubmitted = '0';
        setLoader(true);
        await updateCase(caseData);
        await updateTableCaseByPrimaryId(id, caseData, tableName);

        responseJson = await listSingleCase(caseData.CaseScheduleID);
        const { message, status } = responseJson;
        if (status) {
          const caseDetails = responseJson.data[0];
          caseDetails.id = parseInt(id, 10);
          caseDetails.CaseDate = caseData.CaseDate;
          caseDetails.CaseTime = caseData.CaseTime;
          // caseDetails.Sync = 1;
          updateTableWiseCaseByCaseId(caseDetails.RepCaseNo, caseDetails, tableName);
          let updateSuccessful = await updateCaseByCaseId(caseDetails.RepCaseNo, caseDetails);
          if (!updateSuccessful) {
            updateSuccessful = await updateMissingDGRsByCaseId(caseDetails.RepCaseNo, caseDetails);
          }
          if (!updateSuccessful) {
            updateSuccessful = await updateMissingPOsByCaseId(caseDetails.RepCaseNo, caseDetails);
          }
          if (!updateSuccessful) {
            updateSuccessful = await updateNotBilledByCaseId(caseDetails.RepCaseNo, caseDetails);
          }
          if (!updateSuccessful) {
            updateSuccessful = await updateBilledByCaseId(caseDetails.RepCaseNo, caseDetails);
          }
          if (!updateSuccessful) {
            notify({ type: 'error', message: 'Product notes could not be updated!' });
          }
          onGoBack(goBack);
          setLoader(false);
        } else {
          notify({ type: 'error', message });
        }
      } else {
        caseData.ProductNotes = ProductNotes !== undefined
          ? ProductNotes.charAt(0).toUpperCase() + ProductNotes.slice(1)
          : '';
        caseData.Sync = 1;
        updateTableCaseByPrimaryId(caseData.id, caseData, tableName);
        // updateCaseByPrimaryId(caseData.id, caseData);
        setLoader(false);
        onGoBack(goBack);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFocusAndBlur = async () => {
    try {
      const {
        params: { id }, tableName
      } = this.props;
      const caseRes = await getTableCaseByCaseId(id, tableName);
      // const caseRes = await getCaseByCaseId(id);
      if (Object.keys(caseRes).length > 0) {
        if (caseRes.ProductNotes !== null || caseRes.ProductNotes !== '' || caseRes.ProductNotes !== 'No products used') {
          const html = window.$('#productNotes').val();
          window.$('#productNotes').focus().val('').val(html);
        } else {
          window.$('#productNotes').focus();
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeProductNote = (key, value) => {
    try {
      const { caseRes } = this.state;
      caseRes[key] = value;
      this.setState({
        caseRes
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      await this._getByNotes();
      await this._onFocusAndBlur();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { goBack, handleSubmit, readOnlyProductNotes } = this.props;
    const { caseRes: { ProductNotes } } = this.state;

    return (
      <section>
        <form onSubmit={handleSubmit(this._onSubmitNotes)} form="NotesForm">
          <Header
            actionButton={readOnlyProductNotes ? undefined : { title: 'Save' }}
            title="Product Notes"
            goBack={() => onGoBack(goBack)}
          />

          <section className="section">
            <div className="container">
              <div className="row">
                <div className="col-12 mb-4">
                  <div className="case-data mt-3">
                    <label
                      style={{
                        fontSize: '14px'
                      }}
                      htmlFor="type"
                    >
                      Notes
                    </label>
                    {/* <Field
                      type="text"
                      name="ProductNotes"
                      id="productNotes"
                      className="form-control"
                      placeholder="Notes"
                      component={renderField}
                      onChange={this._onChangeProductNote}
                      autoFocus
                    /> */}
                    {
                      !readOnlyProductNotes ? (
                        <p className={`${isMobile ? '' : 'uc-first-letter'}`}>
                          <textarea
                            name="ProductNotes"
                            id="productNotes"
                            className="form-control"
                            defaultValue={ProductNotes}
                            placeholder="Notes"
                            onChange={(event) => this._onChangeProductNote('ProductNotes', window.UCFirst(event.target.value))}
                            /* eslint-disable-next-line jsx-a11y/no-autofocus */
                            autoFocus
                            rows="4"
                          />
                        </p>
                      ) : (
                        <div
                          /* eslint-disable-next-line react/no-danger */
                          dangerouslySetInnerHTML={{ __html: (typeof ProductNotes !== 'undefined' && ProductNotes !== null) ? ProductNotes.replaceAll('\n', '<br />') : '' }}
                        />
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
          </section>
        </form>
      </section>
    );
  }
}

const withForm = reduxForm({
  form: 'NotesForm',
});

export default withReadOnlyProductNotes(
  withTableName(
    withOnline(
      withForm(
        withGoBack(
          withNotify(
            withLoader(
              withUser(
                Notes
              )
            )
          )
        )
      )
    )
  )
);
